import { render, staticRenderFns } from "./BillInfo.vue?vue&type=template&id=b94adb0e&"
import script from "./BillInfo.vue?vue&type=script&lang=js&"
export * from "./BillInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports